// import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const CreateScheduleConfig = async function(parameters) {
    try {
        const { scheduleConfigObjects } = parameters

        if (scheduleConfigObjects === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: scheduleConfigObjects')
            )

        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/schedule-config`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetScheduleConfig = async function(publicId) {
    try {
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/schedule-config/${publicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}

export const UpdateScheduleConfig = async function(parameters) {
    try {
        const { scheduleConfig, configId } = parameters

        if (configId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: configId')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/schedule-config/${configId}`,
            data: scheduleConfig,
        })
    } catch (e) {
        console.error(e)
    }
}
